import { AxiosResponse } from 'axios'
import { DocumentTypes } from 'pages/Report/types'

const formatBlob = (fileType: DocumentTypes, res: AxiosResponse) => {
    const base64 = res.data
    let blob

    if (fileType === 'CSV' || fileType === 'TXT') {
        blob = new Blob([base64], {
            type: res.headers.contentType
        })
    } else {
        const byteCharacters = atob(base64 as string)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        blob = new Blob([byteArray])
    }
    return blob
}

export const generateFile = (
    typeSelected: DocumentTypes,
    res: AxiosResponse
) => {
    const blob = formatBlob(typeSelected, res)
    const urlFile = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = urlFile
    link.setAttribute(
        'download',
        res.headers['content-disposition']
            .replace(/"/g, '')
            .split('filename=')[1] ?? 'file'
    )

    document.body.appendChild(link)
    link.click()
    link.parentNode?.removeChild(link)
}

export const generateFileUTF = (typeSelected: DocumentTypes, res: AxiosResponse) => {
    const blob = formatBlob(typeSelected, res);
    const urlFile = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = urlFile;

    const disposition = res.headers['content-disposition'] || '';

    let filename: string | null = null;
    const utf8Match = disposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
    if (utf8Match) {
        filename = decodeURIComponent(utf8Match[1]);
    } else {
        const simpleMatch = disposition.match(/filename\s*=\s*"?([^;"]+)"?/i);
        filename = simpleMatch ? simpleMatch[1] : 'file.xlsx';
    }

    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
};


export const generateBlobFile = (
    res: AxiosResponse<Blob>,
    fallbackFileName = 'arquivo.pdf'
) => {
    const contentType =
        res.headers['content-type'] ||
        res.headers['Content-Type'] ||
        'application/octet-stream'

    const blob =
        res.data instanceof Blob
            ? res.data
            : new Blob([res.data], { type: contentType })

    const disposition =
        res.headers['content-disposition'] ||
        res.headers['Content-Disposition'] ||
        ''

    let fileName = fallbackFileName

    const utf8Match = disposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
    if (utf8Match?.[1]) {
        fileName = decodeURIComponent(utf8Match[1])
    } else {
        const simpleMatch = disposition.match(/filename\s*=\s*"?([^;"]+)"?/i)
        if (simpleMatch?.[1]) {
            fileName = simpleMatch[1]
        }
    }

    const urlFile = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = urlFile
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(urlFile)
}